import { Button, Form, Input, Modal, message } from "antd";
import { IVideo } from "../../interfaces";
import { ExclamationCircleFilled, StopFilled, YoutubeFilled } from "@ant-design/icons";
import { useState } from "react";
import { recordApi, studioApi } from "../../api";

interface IProps {
  video: IVideo;
  onDone: (video: IVideo) => void;
}

export default function YoutubeActionButton({ video, onDone }: IProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [form] = Form.useForm();

  const handleUpdate = async () => {
    setIsLoading(true);
    let url = "";
    if (video.status === "schedule") {
      url = "go-live";
    }
    if (["ended", "live"].includes(video.status)) {
      url = `end-live`;
      setCount(count + 1);
    }

    if (video.videoType === "ytst") {
      url = "end-youtube";
    }

    try {
      const { data } = await recordApi.get<IVideo>(url, {
        params: {
          videoId: video._id,
          stream_key: video.stream_key,
          ...(form.getFieldValue("hd_url") !== undefined && {
            hd_video_url: form.getFieldValue("hd_url"),
          }),
          ...(count >= 2 && { force: 1 }),
        },
      });
      onDone(data);
      setIsLoading(false);
      return;
    } catch (error: any) {
      console.log({ error }, "call");
      message.error(
        error?.response?.data?.error ||
        error?.message ||
        "Server Error",
      );
      setIsLoading(false);
    }
  };

  const showConfirmation = () => {
    Modal.confirm({
      title: "Are you sure you want to do this?",
      icon: <ExclamationCircleFilled />,
      content: video.status === "schedule" && (
        <>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            layout="vertical"
            form={form}
          >
            <Form.Item
              label="Enter HD URL"
              name="hd_url"
              rules={[
                {
                  required: false,
                  validator: (_, value) => {
                    if (value.startsWith("https://")) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "URL must start with https://example.m3u8 or https://youtube.com/embed/xysdfsa",
                      ),
                    );
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </>
      ),
      onOk() {
        handleUpdate();
      },
      onCancel() {
        form.resetFields();
      },
    });
  };

  const handleYoutubeGoLive = async () => {
    try {
      await studioApi.post(
        `/youtube/${video._id}/start`
      );

      message.success(
        "YouTube live started successfully"
      );


    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
        "Failed to start YouTube live"
      );
    }
  };
  const handleYoutubeEndLive = async () => {
    try {


      await studioApi.post(
        `/youtube/${video._id}/end`
      );

      message.success(
        "YouTube live ended successfully"
      );

    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
        "Failed to end YouTube live"
      );
    }
  };

  if (video.status === "schedule")
    return (
      <Button
        onClick={() => {
          if (video.videoType === "youtube") {
            handleYoutubeGoLive();
          } else {
            showConfirmation();
          }
        }}
        type="primary"
        loading={isLoading}
        icon={

          <YoutubeFilled />

        }
        style={{
          background:
            "linear-gradient(135deg, #FF0000 0%, #CC0000 100%)",
          border: "none",
          fontWeight: 600,
          boxShadow: "0 4px 14px rgba(255, 0, 0, 0.35)",
          transition: "all 0.2s ease",
        }}
      >
        Go Live
      </Button>
    );



  if (["live"].includes(video.status) && video.videoType !== "yt") {
    return (
      <Button
        onClick={() => {
          if (video.videoType === "youtube") {
            handleYoutubeEndLive();
          } else {
            showConfirmation();
          }
        }}
        danger
        loading={isLoading}
        icon={<StopFilled />}
        style={{
          background:
            "linear-gradient(135deg, #FF0000 0%, #CC0000 100%)",
          border: "1px solid #ff4d4f",
          color: "#fff",
          // borderRadius: "10px",
          fontWeight: 600,
          // height: "42px",
          // paddingInline: "20px",
          boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
          transition: "all 0.2s ease",
        }}
      >
        End Live
      </Button>
    );
  }
  return <div />;
}
